import { API_BASE_URL } from '../config/env';

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = data?.error || data?.message || `Error ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

export async function fetchBotEncuestaList() {
  const res = await fetch(`${API_BASE_URL}/api/bot-encuesta/list`, {
    credentials: 'include'
  });
  return parseJson(res);
}

export async function fetchBotEncuestaLatest(encuestaId) {
  const qs = encuestaId ? `?id=${encodeURIComponent(encuestaId)}` : '';
  const res = await fetch(`${API_BASE_URL}/api/bot-encuesta/latest${qs}`, {
    credentials: 'include'
  });
  return parseJson(res);
}

export async function fetchBotEncuestaDefault() {
  const res = await fetch(`${API_BASE_URL}/api/bot-encuesta/default`, {
    credentials: 'include'
  });
  return parseJson(res);
}

export async function fetchBotEncuestaPublic(token) {
  const res = await fetch(`${API_BASE_URL}/api/bot-encuesta/public/${encodeURIComponent(token)}`);
  return parseJson(res);
}

export async function fetchBotEncuestaReview(encuestaId) {
  const qs = encuestaId ? `?encuesta_id=${encodeURIComponent(encuestaId)}` : '';
  const res = await fetch(`${API_BASE_URL}/api/bot-encuesta/review${qs}`, {
    credentials: 'include'
  });
  return parseJson(res);
}

export async function saveBotEncuesta(payload) {
  const res = await fetch(`${API_BASE_URL}/api/bot-encuesta`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  return parseJson(res);
}

export async function submitBotEncuestaResponse(token, payload) {
  const res = await fetch(`${API_BASE_URL}/api/bot-encuesta/public/${encodeURIComponent(token)}/responses`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  return parseJson(res);
}
